import { flexRender, Table } from '@tanstack/react-table';
import sortDown from 'assets/arrow-narrow-down.svg';
import sortUp from 'assets/arrow-narrow-up.svg';
import sort from 'assets/switch-vertical.svg';

const TableHeader = ({ table }: { table: Table<any> }) => {
  return (
    <thead>
      {table.getHeaderGroups().map((headerGroup) => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header) => {
            return (
              <th key={header.id} colSpan={header.colSpan} className={header.id === 'remove' || header.id === 'edit' ? 'th-style' : ''}>
                {header.isPlaceholder ? null : (
                  <>
                    <div
                      {...{
                        className: header.column.getCanSort() ? 'cursor-pointer select-none flex justify-center items-center' : '',
                        onClick: header.column.getToggleSortingHandler(),
                      }}
                    >
                      {flexRender(header.column.columnDef.header, header.getContext())}
                      {header.column.getCanSort() &&
                        ({
                          asc: <img src={sortUp} className="w-4 h-4 mx-1" alt="sortUp" />,
                          desc: <img src={sortDown} className="w-4 h-4 mx-1" alt="sortDown" />,
                        }[header.column.getIsSorted() as string] ?? <img src={sort} className="w-4 h-4 mx-1" alt="sort" />)}
                    </div>
                  </>
                )}
              </th>
            );
          })}
        </tr>
      ))}
    </thead>
  );
};

export default TableHeader;
